export const getPlanStatus = (row) => {
    let status = 'active';
    if (row.is_cancelled) {
        status = 'cancelled';
    }
    if (new Date(row.end_date) < new Date()) {
        status = 'expired';
    }
    return status;
};

export const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
        case 'active': return 'bg-green-100 text-green-800';
        case 'success': return 'bg-green-100 text-green-800';
        case 'expired': return 'bg-red-100 text-red-800';
        case 'cancelled': return 'bg-gray-100 text-gray-800';
        case 'pending': return 'bg-yellow-100 text-yellow-800';
        case 'suspended': return 'bg-orange-100 text-orange-800';
        default: return 'bg-gray-100 text-gray-800';
    }
};

export const getCustomerIdentifier = (customer) =>
    customer?.ssoid || customer?.sso_id || customer?.user_id || customer?.id || '';

export const formatCustomerDate = (value, includeTime = false) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";

    return new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        // ...(includeTime
        //     ? { hour: "2-digit", minute: "2-digit", hour12: true }
        //     : {}),
    }).format(date);
};

export const formatCustomerCurrency = (amount, currency = "INR") => {
    if (amount === null || amount === undefined || amount === "") return "-";
    const numericAmount = Number(amount);
    if (Number.isNaN(numericAmount)) return `${currency} ${amount}`;

    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
    }).format(numericAmount);
};

export const formatCustomerValue = (value) =>
    value === null || value === undefined || value === "" ? "-" : value;
